export default {"src":"/blog/_next/static/media/language_selector.866849a2.svg","height":20,"width":20};